let config = {
    title: `Anime Pixel Storm`,
    copyright: '© 2025 Yibin Hongyan Network Technology Co., Ltd.',
    email: 'support@animepixelstorm.com',
    policy: 'https://animepixelstorm.com/privacy_policy.html',
    term: 'https://animepixelstorm.com/terms.html',
    introduceTitle: [
        `This is a pixel fantasy world full of endless possibilities, where a crazy and passionate brawl adventure is about to unfold! Here, you can transform into a legendary hero and write your very own pixel all - star legend.`,
    ],
    introduceText: [
        {
            title: '+++All - star Anime Roster+++',
            text: [
                'A vast collection of well - known Japanese anime characters in pixel art style, ready to be summoned.'
            ]
        },
        {
            title: '+++Strategic Combat+++',
            text: [
                `Match characters and skills strategically to win battles, combining both intelligence and combat ability.`
            ]
        },
        {
            title: '+++Diverse Character Development+++',
            text: [
                `Recruit, awaken, level up, and equip characters, and sign exclusive contracts.`
            ]
        },
        {
            title: '+++Multiple Gameplay Modes+++',
            text: [
                'Adventure, battle, collection, and free - for - all modes for a varied gaming experience.'
            ]
        },
        {
            title: '+++Idle Growth+++',
            text: [
                'Characters continue to grow and earn resources even when you’re offline.'
            ]
        }
    ]
}
export default config;